import { IApplicationState } from '../../types/redux';

export function getImageSourcesText({ newbuilding: { imageSources } }: IApplicationState) {
  if (!imageSources || !imageSources.length) {
    return '';
  }

  return `Источники фото: ${imageSources.join(', ')}.`;
}
